import React from 'react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton';
import { ClientSideTable } from './ClientSideTable';

interface Props {
  loading: boolean;
  decisions: ApprovalStatus[];
}
export const DecisionTable = ({ loading, decisions }: Props) => {
  return (
    <div className="status-message">
      <ClientSideTable
        filteringDisabled
        sortingDisabled
        paginationDisabled
        preferencesDisabled
        loading={loading}
        emptyText="No decisions found."
        columnDefinitions={[
          {
            id: 'status',
            header: 'Decision',
            sortingField: 'status',
            cell: (cellInfo: any) => {
              if (!cellInfo) return <></>;
              const isSuccess = cellInfo.status === 'SUCCEEDED';
              return (
                <div
                  className={`flex items-center gap-2 ${isSuccess ? 'text-green-500' : 'text-red-500'}`}
                >
                  <span className="font-bold">{`${isSuccess ? 'Approved' : 'Rejected'}`}</span>
                </div>
              );
            },
          },
          {
            header: 'Message',
            id: 'statusMessage',
            cell: (cellInfo: any) => {
              if (!cellInfo?.statusMessage) return <></>;
              return (
                <div>
                  <div className="max-h-12 overflow-auto">
                    <p>
                      {cellInfo.statusMessage}
                      <CopyToClipboardButton
                        icon="content_copy"
                        variant="link"
                        data={cellInfo.statusMessage}
                      />
                    </p>
                  </div>
                </div>
              );
            },
          },
          {
            header: 'Username',
            id: 'createdBy',
            cell: (cellInfo: any) => {
              if (!cellInfo.createdBy) return <></>;
              return (
                <div className="" style={{ pointerEvents: 'all' }}>
                  <div className="max-h-12 overflow-auto">
                    <p>
                      {cellInfo.createdBy}
                      <CopyToClipboardButton
                        icon="content_copy"
                        variant="link"
                        data={cellInfo.createdBy}
                      />
                    </p>
                  </div>
                </div>
              );
            },
          },
        ]}
        data={decisions}
        title={'Decisions'}
        error={null}
      />
    </div>
  );
};
